import {
    postStudentsCreateReducer,
    postStudentsWrapperCreateReducer,
    getStudentsReducer,
    getStudentsReceiptsReducer,
} from '../../slices/gq-admin/students';

export const gqAdminStudentsReducers = {
    postStudentsCreate: postStudentsCreateReducer,
    postStudentsWrapperCreate: postStudentsWrapperCreateReducer,
    getStudents: getStudentsReducer,
    getStudentsReceipts: getStudentsReceiptsReducer,
};
